const htmlToken = {
	node: "html",
	getAttrs: (tok) => tok?.attrs,
};

export default htmlToken;
